namespace SP {
    export enum PickDistancePreference {
        Combined = 0,
        CombinedTolerant = 1,
        CombinedTolerantPlus = 2,
        Avrage = 3,
        AvrageTolerant = 4,
        AvrageTolerantPlus = 5,
    }
}